import * as React from 'react';
import { useFela } from 'react-fela';
import { createBoxCSSStyle } from './Box';
import { createResponsiveStyles } from './utils';
export const createFlexContainerCSSStyle = (props) => {
    const { inline, direction, nowrap, center, justifyContent, alignItems } = props;
    const styles = {};
    if (inline) {
        Object.assign(styles, { display: 'inline-flex' });
    }
    else {
        Object.assign(styles, { display: 'flex' });
    }
    if (direction) {
        Object.assign(styles, { flexDirection: direction });
    }
    if (nowrap) {
        Object.assign(styles, { flexWrap: 'nowrap' });
    }
    else {
        Object.assign(styles, { flexWrap: 'wrap' });
    }
    if (justifyContent) {
        Object.assign(styles, { justifyContent });
    }
    if (alignItems) {
        Object.assign(styles, { alignItems });
    }
    if (center) {
        const centerStyles = {
            justifyContent: justifyContent || 'center',
            alignItems: alignItems || 'center',
            textAlign: 'center',
        };
        Object.assign(styles, centerStyles);
    }
    return styles;
};
function createFlexCSSStyle(props, theme, outsideMediaQuery) {
    return {
        ...createBoxCSSStyle(props, theme, outsideMediaQuery),
        ...createFlexContainerCSSStyle(props),
    };
}
export function Flex(props) {
    const { as = 'div', style, onClick, onMouseDown, onMouseOut, onMouseOver, onScroll, htmlAttrs, testId, innerRef, children, ...styleProps } = props;
    const { css, theme } = useFela();
    const boxStyles = createResponsiveStyles(styleProps, createFlexCSSStyle, theme);
    return React.createElement(as, {
        className: css([boxStyles, style]),
        'data-testid': testId,
        onClick,
        onMouseDown,
        onMouseOut,
        onMouseOver,
        onScroll,
        ...htmlAttrs,
        ref: innerRef,
    }, children);
}
export function HeaderFlex(props) {
    return React.createElement(Flex, { as: "header", ...props });
}
export function NavFlex(props) {
    return React.createElement(Flex, { as: "nav", ...props });
}
export function SectionFlex(props) {
    return React.createElement(Flex, { as: "section", ...props });
}
export function ArticleFlex(props) {
    return React.createElement(Flex, { as: "article", ...props });
}
export function AsideFlex(props) {
    return React.createElement(Flex, { as: "aside", ...props });
}
export function FooterFlex(props) {
    return React.createElement(Flex, { as: "footer", ...props });
}
export function FigCaptionFlex(props) {
    return React.createElement(Flex, { as: "figcaption", ...props });
}
export function FigureFlex(props) {
    return React.createElement(Flex, { as: "figure", ...props });
}
//# sourceMappingURL=Flex.js.map